import { Alert } from '@mui/material';
import { Link } from 'react-router-dom';
import { useLocalizedText } from '../../hooks/useLocalizedText';

export const BasketRegisterAlert = () => {
  const t = useLocalizedText();

  return (
    <Alert severity='info'>
      {t('basket.register_alert.part_1')}{' '}
      <Link to='/giris-yap'>{t('basket.register_alert.part_2')}</Link>{' '}
      {t('basket.register_alert.part_3')}
    </Alert>
  );
};
